// Find out where it's running (localhost, test server or production)
function APILocation() {
  const URL = window.location.href;

  if (URL.indexOf("torneio-dev.herokuapp.com") > 0) {
    return "https://torneio-dev.herokuapp.com/v1";
  }

  if (URL.indexOf("torneio.herokuapp.com") > 0) {
    return "https://torneio.herokuapp.com/v1";
  }

  if (URL.indexOf("localhost") > 0) {
    return "http://localhost:8011/v1";
  }

  // Defaults to production api
  return "https://torneio.herokuapp.com/v1";
}

function TendaEduAPI() {
  const URL = window.location.href;
  if (URL.indexOf("torneio.herokuapp.com") > 0) {
    return "https://api.layers.digital/v1";
  }

  if (URL.indexOf("torneio-dev.herokuapp.com") > 0) {
    return "https://api.test.layers.digital/v1";
  }

  if (URL.indexOf("localhost") > 0) {
    return "http://localhost:8009/v1";
  }

  // Defaults to production api
  return "https://api.layers.digital/v1";
}

export default {
  API_URL: APILocation(),

  TendaEduAPI: TendaEduAPI(),
};



// WEBPACK FOOTER //
// ./src/environment.js